<div class="modal-header">
    <h4 class="modal-title fw-bold" id="updatePersonalHeader" jhiTranslate="userProfile.home.title">Update user profile</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <div class="row p-3">
        <div class="col-12">
            <form name="form" #f="ngForm">
                <div class="mb-3 row">
                    <label for="firstName" class="col-4 col-form-label" jhiTranslate="userProfile.update.field.firstName">First Name</label>
                    <input type="text" class="form-control col-4" name="firstName" id="firstName" [(ngModel)]="model.firstName" #firstName="ngModel" jhi-forbiddenCharactersValidator [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" maxlength="20" required/>
                </div>
                <div class="mb-3 row">
                    <label for="lastName" class="col-4 col-form-label" jhiTranslate="userProfile.update.field.lastName">Last Name</label>
                    <input type="text" class="form-control col-4" name="lastName" id="lastName" [(ngModel)]="model.lastName" #lastName="ngModel" jhi-forbiddenCharactersValidator [ngClass]="{ 'is-invalid': f.submitted && lastName.invalid }" maxlength="50" required/>
                </div>
                <div class="mb-3 row">
                    <label for="email" class="col-4 col-form-label" jhiTranslate="userProfile.update.field.email">Email</label>
                    <input type="text" class="form-control col-4" name="email" id="email" [(ngModel)]="model.email" validateEmail #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" maxlength="255" required/>
                </div>
                <div class="mb-3 row">
                    <label for="password" class="col-4 col-form-label" jhiTranslate="userProfile.update.field.password.confirm">Confirm your password</label>
                    <input type="password" class="form-control col-4" name="password" id="password" [(ngModel)]="model.password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required/>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button (click)="update(f)" [disabled]="!isFormValid(f)" class="btn btn-primary">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.update">Update</span>
    </button>
</div>
